import React, {Component} from 'react';
import PropTypes from 'prop-types';
import {Button, Glyphicon, Row, Col} from 'react-bootstrap';
import {NormalizationPreviewWellStatus} from '../../../constants/dataEnum';
import FmlxNumericInputWithButton from '../../../components/FmlxNumericInputWithButton';
import './NormalizationContainer.scss';

/* eslint-disable */
class NormalizationViewTargetSetting extends Component {
  constructor(props) {
    super(props);

    this.state = {
      initialTargetConcentration: this.props.normalizationState.targetConcentration,
      initialCurrentVolume: this.props.normalizationState.currentVolume,
    };
    this.targetConcInput = null;
    this.currVolInput = null;
  }

  shouldComponentUpdate(nextProps) {
    if (
      this.props.normalizationState.targetConcentration !==
      nextProps.normalizationState.targetConcentration
    ) {
      return true;
    }
    if (
      this.props.normalizationState.currentVolume !== nextProps.normalizationState.currentVolume
    ) {
      return true;
    }
    if (
      this.props.normalizationState.selectedLabware !== nextProps.normalizationState.selectedLabware
    ) {
      return true;
    }
    if (
      this.props.normalizationState.lowestConcentration !==
      nextProps.normalizationState.lowestConcentration
    ) {
      return true;
    }
    return false;
  }

  handleClickResetButton() {
    const initialTargetConcentration = this.props.normalizationState.defaultTargetSetting.targetConcentration;
    const initialCurrentVolume = this.props.normalizationState.defaultTargetSetting.currentVolume;
    this.generatePreviewData(initialTargetConcentration, initialCurrentVolume);
    this.targetConcInput.state.inputValue = initialTargetConcentration;
    this.currVolInput.state.inputValue = initialCurrentVolume;
    this.props.setTargetConcentration(initialTargetConcentration);
    this.props.setNormalizationCurrentVolume(initialCurrentVolume);
  }

  handleChangeTargetConcentration(value) {
    const numValue = isNaN(parseFloat(value)) ? 0 : parseFloat(value);
    this.generatePreviewData(numValue, this.props.normalizationState.currentVolume);
    this.props.setTargetConcentration(Math.round(numValue * 10) / 10);
  }

  handleChangeCurrentVolume(value) {
    const numValue = isNaN(parseFloat(value)) ? 0 : parseFloat(value);
    this.generatePreviewData(this.props.normalizationState.targetConcentration, numValue);
    this.props.setNormalizationCurrentVolume(numValue);
  }

  generatePreviewData(targetConcentration, currentVolume) {
    const { previewData, selectedLabware } = this.props.normalizationState;

    const newData = previewData.slice();
    for (let idx = 0; idx < newData.length; idx++) {
      let diluentVolume = 0.0;
      if (targetConcentration < newData[idx].reagentCurrentConcentration) {
        diluentVolume =
          (currentVolume * newData[idx].reagentCurrentConcentration) / targetConcentration -
          currentVolume;
        diluentVolume = Math.round(diluentVolume * 10) / 10;
      }

      // calculate well status based on diluent volume and plate's working capacity
      let wellStatus = NormalizationPreviewWellStatus.NORMAL;
      if (
        diluentVolume + currentVolume > selectedLabware.workingCapacity ||
        targetConcentration > newData[idx].reagentCurrentConcentration
      ) {
        wellStatus = NormalizationPreviewWellStatus.INVALID;
      } else if (diluentVolume <= 0) {
        wellStatus = NormalizationPreviewWellStatus.SKIPPED;
      }

      newData[idx].diluentVol = diluentVolume;
      newData[idx].status = wellStatus;
    }

    this.props.setPreviewData(newData);
  }

  render() {
    const {
      selectedLabware,
      targetConcentration,
      lowestConcentration,
      currentVolume,
    } = this.props.normalizationState;

    return (
      <div className="setting-container">
        <div className="setting-info-section">
          <Row>
            <Col xs={9} sm={9} md={9} className={'setting-info-text'}>
              Specify the target concentration and the reagent volume in each well.
            </Col>
            <Col xs={3} sm={3} md={3}>
              <Button className="setting-info-button" onClick={() => this.handleClickResetButton()}>
                <Glyphicon glyph={'repeat'} />
              </Button>
            </Col>
          </Row>
        </div>
        <div className="spacer-v">&nbsp;</div>
        <div className="block-section">
          <div className="sub-section-title">Target Settings</div>
          <Row>
            <Col xs={12} sm={12} md={12} style={{ fontSize: '12px' }}>
              Target Concentration
            </Col>
          </Row>
          <Row>
            <Col xs={12} sm={12} md={12}>
              <FmlxNumericInputWithButton
                inputClassName="setting-input"
                plusButtonClassName="plus-minus-button"
                minusButtonClassName="plus-minus-button"
                placeholder="0"
                defaultValue={targetConcentration}
                stepValue={1}
                decimalPrecision={1}
                ref={(targetConcInput) => {
                  this.targetConcInput = targetConcInput;
                }}
                onChange={(value) => {
                  this.handleChangeTargetConcentration(value);
                }}
                allowDecimal
              />
            </Col>
          </Row>
          <Row>
            <Col xs={12} sm={12} md={12} style={{ fontSize: '12px' }}>
              Current Volume
            </Col>
          </Row>
          <Row>
            <Col xs={12} sm={12} md={12}>
              <FmlxNumericInputWithButton
                inputClassName="setting-input"
                plusButtonClassName="plus-minus-button"
                minusButtonClassName="plus-minus-button"
                placeholder="0"
                defaultValue={currentVolume}
                stepValue={1}
                decimalPrecision={1}
                ref={(currVolInput) => {
                  this.currVolInput = currVolInput;
                }}
                max={this.props.normalizationState.selectedLabware.workingCapacity}
                onChange={(value) => {
                  this.handleChangeCurrentVolume(value);
                }}
                allowDecimal
              />
            </Col>
          </Row>
        </div>
        <div className="spacer-v">&nbsp;</div>
        <div className="block-section">
          <Row>
            <Col xs={8} sm={8} md={8}>
              Well Capacity (µL)
            </Col>
            <Col xs={4} sm={4} md={4}>{`: ${selectedLabware.workingCapacity}`}</Col>
          </Row>
          <Row>
            <Col xs={8} sm={8} md={8}>
              Lowest Concentration
            </Col>
            <Col xs={4} sm={4} md={4}>{`: ${lowestConcentration}`}</Col>
          </Row>
        </div>
      </div>
    );
  }
}

export default NormalizationViewTargetSetting;

NormalizationViewTargetSetting.propTypes = {
  normalizationState: PropTypes.any,
  setTargetConcentration: PropTypes.func,
  setNormalizationCurrentVolume: PropTypes.func,
  setPreviewData: PropTypes.func,
};
/* eslint-enable */
